import { useEffect, useState } from 'react';

// Spec §12: mobile portrait is out of scope for v0, but the page must say "turn
// your phone sideways" rather than render a broken layout.
//
// The watch screen puts five icons in the left letterbox margin and four in the
// right. In portrait there is no letterbox to put them in, so the layout does not
// degrade gracefully — it collapses. Better to ask for a rotation than to ship a
// reviewer a broken interface and lose the session.
//
// Width-based rather than height-based: a laptop in a short window is not a phone
// in portrait, and should not be nagged.
export function PortraitOrientationNotice() {
  const [isPortraitPhone, setIsPortraitPhone] = useState(false);

  useEffect(() => {
    const check = () => {
      setIsPortraitPhone(window.innerHeight > window.innerWidth && window.innerWidth < 700);
    };
    check();
    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);
    return () => {
      window.removeEventListener('resize', check);
      window.removeEventListener('orientationchange', check);
    };
  }, []);

  if (!isPortraitPhone) return null;

  return (
    <div className="rotateNotice" role="alert">
      <div className="rotateNoticeInner">
        <div className="rotateGlyph">⟲</div>
        <b>Turn your phone sideways</b>
        <p>The icons live in the margins either side of the video, so this needs landscape.</p>
      </div>
    </div>
  );
}
